import $ from "jquery";
import Marquee from "../src/Marquee";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let info_marquee_matchMedia = gsap.matchMedia();
info_marquee_matchMedia.add("(max-width: 768px)", () => {
  $(".info-section__photos").addClass("marquee");
  $(".info-section__photos img").addClass("marquee__item");
  const info__marquee = new Marquee($(".info-section__photos")[0], {
    speed: 0.5,
    direction: "left",
  });

  return () => {
    info__marquee.destroy();
    $(".info-section__photos").removeClass("marquee");
    $(".info-section__photos img").removeClass("marquee__item");
  };
});

let photosTl = gsap.timeline({
  scrollTrigger: {
    trigger: ".info-section__photos",
    start: "top 60%",
  },
});

photosTl.from(".info-section__photos img", {
  y: 70,
  duration: 2.5,
  ease: "ease",
  stagger: 0.1,
});
